/**
 * Formatting for the daily-allowance reset, shown in the out-of-credits gate.
 *
 * `resetsAt` is a unix instant, so it means the same thing in every timezone —
 * only the rendering differs. The countdown is therefore timezone-proof, and
 * the absolute time is rendered in the viewer's own zone rather than the
 * backend's (which resets at 18:00 Europe/London, not local midnight).
 */
/** e.g. "5h 12m", "12m", or "less than a minute" when the reset is imminent. */
export const formatResetCountdown = (resetsAtSeconds, nowMs) => {
    const totalMinutes = Math.floor((resetsAtSeconds * 1000 - nowMs) / 60_000);
    if (totalMinutes <= 0)
        return "less than a minute";
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours === 0)
        return `${minutes}m`;
    return `${hours}h ${minutes}m`;
};
/** Absolute reset time in the viewer's locale, for the hover tooltip. */
export const formatResetLocalTime = (resetsAtSeconds) => new Date(resetsAtSeconds * 1000).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
});
export const resetTooltip = (resetsAtSeconds) => `Refreshes at ${formatResetLocalTime(resetsAtSeconds)} your local time`;
//# sourceMappingURL=creditsReset.js.map